<template>
  <f7-page id="login-page" name="login-page" @page:beforein="init()" @page:afterin="afterin" class="bg-color-white">
    <f7-navbar class="view-mobile no-border bg-color-white">
        <f7-nav-left class="back-button">
            <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
        </f7-nav-left>
        <f7-nav-right></f7-nav-right>
    </f7-navbar>

    <f7-block>
      <div class="mb-20">
        <div class="wandr-level-4 mt-lg mb-sm">{{$t('label-welcome-login')}}</div>
      </div>

      <transition name="fade">
        <f7-card
            class   ="alert alert-danger mb-20"
            v-show  ="alertCard.show"
        >
            <div v-html="alertCard.title" slot="header"></div>
            <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
        </f7-card>
      </transition>

      <f7-button large fill class="bg-color-red2 text-color-white mb-20 display-flex align-items-center justify-content-center b fs-16" @click="singpassLogin" :disabled="false">
        {{$t('login-login-with')}} <img :src="require('@/assets/img/icon/icon-singpass.svg')" class="ml-sm img-white" style="height:15px; margin-top: 6px;" />
      </f7-button>


      <div class="text-align-center mb-xl">
        <div class="div-button ios mb-20" @click="openAppleSignIn"><f7-icon f7="logo_apple" size="20px" class="mr-sm"></f7-icon> {{$t('general-text-apple-sign-in')}}</div>

        <div class="div-button google" @click="openGoogleSignIn">
          <img :src="require('@/assets/img/icon/icon-google-colors.svg')" style="height:20px" class="mr-sm"/> {{$t('general-text-google-sign-in')}}
        </div>
      </div>

      <div class="mb-20 divider-line">
        <span>{{$t('general-text-or')}}</span>
      </div>

      <div class="">
        <div class="mb-20 fs-16 b">{{ $t('login-manually-text') }}</div>
        <f7-list class="form-group" style="">
          <f7-list-input
            input-id      ="email"
            name          ="email"
            type          ="email"
            class         =""
            placeholder   =""
            @input        ="email = $event.target.value;validateInput($event.target);validateNextButton();"
            :label        ="$t('general-text-email')"
            :value       ="email"
            outline
            floating-label
            autocomplete  ="off"
            clear-button
            required
          >

          </f7-list-input>

          <f7-list-input
            input-id      ="password"
            name          ="password"
            :type         ="passwordInputType"
            class         ="password"
            placeholder   =""
            @input        ="password = $event.target.value;validateInput($event.target);validateNextButton()"
            minlength     ="8"
            :label        ="$t('general-text-password')"
            outline
            floating-label
            required
          >
            <div class="toggle-password" @click="showHidePassword" id="password-icon" toggle="#password-field" slot="content-end" style="">
              <i class="f7-icons">eye_slash</i>
            </div>
          </f7-list-input>
        </f7-list>

        <div class="text-align-right mb-md">
          <a class="wandr-level-3" @click="forgotPassword">{{$t('label-forgot-password')}}</a>
        </div>
      </div>

      <div id="slide-captcha-container">
        <SlideVerify :l="42"
          :r="10"
          :w="320"
          :h="180"
          :slider-text="$t('captcha-slider-text')"
          @success="onSuccess"
          @fail="onFail"
          @refresh="onRefresh"
          @invalid="onFormInvalid"
          page="login"
          :email-valid="isEmailValid"
          :password-valid="isPasswordValid"
          :key="componentKey"
          v-if="isRenderCaptcha"
          ref="sliderCaptcha"
          >
        </SlideVerify>
        <div>{{msg}}</div>
      </div>

      <div class="my-2 re-anchor-wrapper">
        <Recaptcha v-if="isShowRecaptchaV2 && sitekeyV2 != ''" :sitekey="sitekeyV2" name="login" @validate-form="validateNextButton"/>
      </div>

      <f7-button class="mb-sm mt-xl" large fill @click="goToNextPage" :disabled="!isNextButtonValid">
        {{$t('general-btn-login')}}
      </f7-button>


      <div class="fs-12 text-color-black text-align-center" v-html="$t('label-tnc-login', ['/#!/guest-tnc'])"></div>
      <div class="text-align-center pt-xxl fs-14" v-html="$t('login-register-now', ['/register'])"></div>
    </f7-block>

    <ModalInfo
      :modal-title="modalInfo.title"
      :modal-content="modalInfo.content"
      :sheet-opened="modalInfo.opened"
      :buttons="modalInfo.buttons"
      @closeModal="closeModal($event)"
    />

    <!-- <f7-toolbar no-hairline="true" position="bottom">something 2</f7-toolbar> -->
  </f7-page>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import Recaptcha from '../components/Recaptcha.vue';
  import SlideVerify from '../components/SlideVerify.vue';
  import ModalInfo from '../components/sheet-modal-info.vue'
  import CryptoAES from 'aes-ecb'
  import store from '../store'
  import ApiService from "../services/api-main";
  import { check } from '@/plugins/helper';

  export default {
    async mounted (){
      this.email = ApiService.getFormData("custEmail")

      if(this.email && this.email.trim() != ""){
        this.validateInput({name: "email", value: this.email});
      }

      const appRedirPath = await this.$api.misc.checkDeviceRedirect()
      if(appRedirPath){ window.location.href = appRedirPath; return; }
      this.determineAppBranchId(this.$f7.device.desktop)
      //console.log("state.appBranchId " + this.$store.state.misc.appBranchId);
      //console.log('resetLoginState')
      this.$store.commit('auth/resetLoginState')

      //let $$ = this.Dom7;
      this.getRecaptchaKey();

      window.singpassLoginCallback  = this.singpassLoginCallback;
      window.singpassLoginFailed    = this.singpassLoginFailed;
      window.addEventListener('storage', this.handleSingpassStorage);

      const ls = this.$f7route.query['ls'];

      if(ls && ls.trim() != ""){
        if(ls == "exceeded"){
          this.showAlert(true, this.$t('alert-login-max-attempt', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
        }
      }
    },
    destroyed() {
      if (window.singpassLoginCallback) window.singpassLoginCallback = null;
      if (window.singpassLoginFailed) window.singpassLoginFailed = null;
      window.removeEventListener('storage', this.handleSingpassStorage);
    },
    data() {
      return {
        email                 : "",
        password              : "",
        isEmailValid          : false,
        isPasswordValid       : false,
        isNextButtonValid     : false,
        isShowRecaptchaV2     : false,
        sitekey               : "",
        sitekeyV2             : "",
        recaptcha             : "",
        recaptchaV2           : "",
        alertCard: {
            show   : false,
            title  : "",
            content: ""
        },
        isCaptchaVerified     : false,
        msg                   : "",
        routerTo              : "",
        componentKey          : 0,
        isRenderCaptcha       : false,
        passwordInputType     : "password",
        checkWindow           : undefined,
        checkTimer            : null,
        modalInfo: {
            title   : "",
            content : "",
            opened  : false,
            buttons : []
        }
      };
    },
    methods: {
      ...mapActions('auth', ['login', 'logout']),
      ...mapActions('registration', ['setIsAxsr']),
      ...mapActions('misc', ['determineAppBranchId']),

      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },
      async init(){
        this.setIsAxsr(false)
        await this.logout();
      },
      async getRecaptchaKey(){
        this.showPreloader();
        const recaptchaKey = await this.$api.registration.getRecaptchaKey();
        //const recaptchaKey = {"status":"1223","message":null,"result":{}}

        if(recaptchaKey.result.siteKey && recaptchaKey.result.siteKeyV2){
          console.log("GOT THE SITEKEY")
          this.sitekey = recaptchaKey.result.siteKey;
          this.sitekeyV2 = recaptchaKey.result.siteKeyV2;

          if(this.sitekey != "" && this.sitekeyV2 != ""){
            this.loadScriptByURL("recaptcha-key", "https://www.google.com/recaptcha/api.js?render="+this.sitekey, function () {
              console.log("script loaded");
            });

            var registrationData = store.state.registration;
            registrationData.recaptchaV2 = "";

            this.forceRerender();
          }

          this.hidePreloader();
        }else{
          console.log("DISPLAY ERROR MSG FOR SITEKEY NULL")
          this.hidePreloader();
          this.$f7.dialog.alert(this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
        }

      },
      loadScriptByURL(id, url, callback){
        const isScriptExist = document.getElementById(id);

        if (!isScriptExist) {
          var script = document.createElement("script");
          script.type = "text/javascript";
          script.src = url;
          script.id = id;
          script.onload = function () {
            if (callback) callback();
          };
          document.body.appendChild(script);
        }

        if (isScriptExist && callback) callback();
      },
      forceRerender() {
        let $$ = this.Dom7;
        $$("#slide-captcha-container").show();
        this.isShowRecaptchaV2 = false;
        this.isRenderCaptcha = true;
        this.componentKey += 1;
      },
      validateInput(e) {
        var inputName   = e.name;
        var keyName     = "regis-"+e.name;
        var translation;

        var validate = true;
        if(inputName == "email"){
          validate = check.validPattern("email", e.value);
        }

        if(inputName == "password"){
          //validate   = check.validPattern("password", e.value.trim());
          validate = e.value.trim() == "" ? false : true
        }

        if(!validate){
          translation = keyName + "-rule";

          if(e.value.trim() == ""){
            translation = keyName + "-empty";
          }

          this.setInputState(inputName, this.$t(translation));
          if(inputName == "email"){
            this.isEmailValid = false;
          }else if(inputName == "password"){
            this.isPasswordValid = false;
          }
          this.isNextButtonValid = false;
          return false;
        }

        var loginData = store.state.misc;
        if(inputName == "email"){
          this.isEmailValid = true;
          loginData.email = this.email;
        }else if(inputName == "password"){
          this.isPasswordValid = true;
          loginData.password = this.password;
        }

        this.setInputState(inputName, true);
        return true;
      },
      async finalValidation(){
        await this.validateInput({name: "email", value: this.email});
        await this.validateInput({name: "password", value: this.password});
      },
      validateNextButton(){
        var isRecaptchaValid = false;

        if(!this.isShowRecaptchaV2 && this.sitekey != ""){
          isRecaptchaValid = true;
        }else if(this.isShowRecaptchaV2 && this.sitekeyV2 != ""){
          var registrationData = store.state.registration;
          if(registrationData.recaptchaV2.trim() != ""){
            isRecaptchaValid = true;
          }
        }

        this.isNextButtonValid = this.isEmailValid && this.isPasswordValid && isRecaptchaValid && this.isCaptchaVerified

      },
      singpassLogin(){
        const self = this;
        self.showPreloader();

        // Reclaim the global callback handoff every time we start our own
        // flow, in case another component (e.g. session-refresh.vue) last
        // claimed it for its own popup. See DR-2118 for the failure mode
        // this prevents - the popup calling back into a stale instance
        // whose own checkWindow has nothing to do with this popup.
        window.singpassLoginCallback = this.singpassLoginCallback;
        window.singpassLoginFailed   = this.singpassLoginFailed;

        const isUsingInAppBrowser = self.isMyInfoUseInAppBrowser();
        if(!isUsingInAppBrowser) {
          self.checkTimer = setInterval(function(){ if(self.checkWindow.closed) {self.singpassLoginCompleted(false);} }, 1000);
        }

        this.$api.customer.getSingpassURL(isUsingInAppBrowser, 0).then(function(response) {
          if(response && response != undefined && response.value != '') {
            if(isUsingInAppBrowser) {
              self.openMyInfoInMobile(response.value);
              self.$root.$once("proceedMyInfoMobileCallback", (isUserCancel, state, code) => {
                if(isUserCancel) {
                  self.singpassLoginCompleted(false);
                } else {
                  self.singpassLoginCallback(state, code);
                }
              });
            } else if(self.checkWindow !== undefined) {
              self.checkWindow.location.replace(response.value);
            } else {
              self.checkWindow = window.open(response.value, '_blank', "fullscreen=1");
            }
          } else {
            self.hidePreloader();
          }
        });
      },
      // DR-2118 follow-up: login-singpass-callback.vue's fallback when it has no
      // window.opener reference at all (some mobile WebViews lose this even for a
      // same-origin popup) - it writes here instead, and any listening tab/window
      // picks it up via the 'storage' event, which doesn't need an opener/popup
      // object reference. Route through window.singpassLoginCallback (the reclaimed
      // global), not this.singpassLoginCallback directly, so only the currently
      // active flow's instance handles it.
      handleSingpassStorage(event) {
        if (event.key !== 'singpassCallbackPending' || !event.newValue) return;
        try {
          const payload = JSON.parse(event.newValue);
          if (window.singpassLoginCallback) {
            window.singpassLoginCallback(payload.state, payload.code);
          }
        } catch (e) {
          // malformed payload - nothing to recover
        } finally {
          localStorage.removeItem('singpassCallbackPending');
        }
      },
      singpassLoginCallback(state, code){
        if (code == '' || state == '') {
          this.singpassLoginFailed(1);
        }
        const self = this;
        self.$api.customer.singpassLogin(self.isMyInfoUseInAppBrowser(), state, code).then(function(result) {
          self.hidePreloader();
          if(result.status == '0100') {
            self.setCustomerUsingBiometry(result.result.p2hCustomerId, 2);
            self.singpassLoginCompleted(true);
          } else if(result.status == "WN00120") { // Customer not found
            self.singpassLoginFailed(2);
          } else if(result.status == "0131") { // general error
            self.singpassLoginFailed(3);
          }else { // singpass service unavailable
            self.singpassLoginFailed(1);
          }
        }).catch(function() {
          self.singpassLoginFailed(1);
        });
      },
      singpassLoginCompleted(navigateToNextPage){
        this.hidePreloader();
        this.closePopupOnMobile();
        if(this.checkWindow !== undefined) {
          clearInterval(this.checkTimer);
          this.checkWindow.close();
          this.checkWindow = undefined;
        }
        if(navigateToNextPage) {
          this.$f7router.navigate("/home");
        }
      },
      singpassLoginFailed(errorType){
        const self = this;
        this.hidePreloader();
        this.closePopupOnMobile();
        if(this.checkWindow !== undefined) {
          clearInterval(this.checkTimer);
          this.checkWindow.close();
          this.checkWindow = undefined;
        }

        let modalTitle = "";
        let modalContent = "";
        let buttons = [];
        switch (errorType) {
          case 2: {
            modalTitle    = this.$t('login-singpass-user-not-found');
            modalContent  = this.$t('login-singpass-user-not-found-desc', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK});
            let button = {};
            let imgURL = self.getImg('icon/icon-singpass.svg');
            button.index = 1;
            button.href  = "/register";
            button.text  = this.$t('login-singpass-button-register', [imgURL]);
            button.styleClass = "bg-color-red2 text-color-white vam mb-xl display-flex align-items-center justify-content-center button-square"
            buttons.push(button);
            break;
          }
          case 3: {
            modalTitle    = this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK});
            modalContent  = "";
            break;
          }
          default:
            modalTitle    = this.$t('login-singpass-unavailable');
            modalContent  = "";
            break;
        }

        this.modalInfo.title = modalTitle;
        this.modalInfo.content = modalContent;
        this.modalInfo.opened = true;
        this.modalInfo.buttons = buttons;
      },
      closeModal(){
        this.modalInfo.opened = false;
      },
      async goToNextPage(){
        await this.finalValidation();

        if (this.email != '' && this.password != '') {
          this.showPreloader();

          // CHECK EMAIL & PASSWORD VALIDITY
          var isFormValid = false;
          isFormValid = this.isEmailValid && this.isPasswordValid

          if(isFormValid){
            ApiService.saveFormData("custEmail", this.email);

            // var today = new Date();
            // var dd = String(today.getDate()).padStart(2, '0');
            // var MM = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
            // var yy = today.getFullYear().toString().substr(-2);
            // var todayNew = MM + dd + yy;
            const randVal = await ApiService.getRandomValue();
            //console.log("newdate: "+todayNew);

            var loginData = store.state.misc;
            loginData.email = this.email;
            loginData.password = this.password;


            window.grecaptcha.ready(() => {
              window.grecaptcha.execute(this.sitekey, { action: 'submit' }).then(token => {
                //console.log("g-recaptcha-response : "+token);
                this.recaptcha = token;
                var recaptchaData = store.state.registration;
                recaptchaData.recaptcha = token;

                var secretKey = process.env.VUE_APP_PSSTK+randVal;
                //console.log("secret key : "+secretKey)

                var encryptedPassword = CryptoAES.encrypt(secretKey, this.password);
                var loginData = store.state.misc;

                this.login({userId: this.email, password: encryptedPassword }).then((result)=>{
                  //console.log(JSON.stringify(result))
                  let $$ = this.Dom7;
                  if (this.authenticationSuccess) {
                    loginData.otp.routerTo = 'loginSuccess';
                    this.$f7router.navigate("/otp");
                  }else if(result.status == "WN00115"){ // WRONG PASSWORD
                    this.showAlert(true, this.$t('login-err-WN00115'))
                    this.isShowRecaptchaV2 = false;
                    this.setInputState('email', false)
                    this.setInputState('password', false)
                    this.isNextButtonValid = false;
                    this.isCaptchaVerified = false;
                    this.forceRerender();
                    $$("#slide-captcha-container").show();
                  }else if(result.status == "WN00120"){ // UNREGISTERED EMAIL
                    this.showAlert(true, this.$t('reset-password-email-not-found'))
                    this.isShowRecaptchaV2 = false;
                    this.setInputState('email', false)
                    this.setInputState('password', false)
                    this.isNextButtonValid = false;
                    this.isCaptchaVerified = false;
                    this.forceRerender();
                    $$("#slide-captcha-container").show();
                  }else if(result.status == "WN00138"){ // MULTIPLE EMAIL EXIST
                    this.showAlert(true, this.$t('login-err-WN00138'))
                    this.isShowRecaptchaV2 = false;
                    this.setInputState('email', false)
                    this.setInputState('password', false)
                    this.isNextButtonValid = false;
                    this.isCaptchaVerified = false;
                    this.forceRerender();
                    $$("#slide-captcha-container").show();
                  }else if(result.status == "0107"){ // EXCEDEED MAX ATTEMPT
                    this.showAlert(true, this.$t('alert-login-max-attempt', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}))
                    this.isShowRecaptchaV2 = false;
                    this.setInputState('email', false)
                    this.setInputState('password', false)
                    this.isNextButtonValid = false;
                    this.isCaptchaVerified = false;
                    this.forceRerender();
                    $$("#slide-captcha-container").show();
                  }else if(result.status == "WN00101"){ // error recaptcha
                    //console.log("ERROR RECAPTCHA -> display V2")
                    let $$ = this.Dom7;
                    $$("#slide-captcha-container").hide();
                    this.isShowRecaptchaV2 = true;
                    this.validateNextButton();
                  }else if(result.status == "0105"){ // EMAIL INACTIVE (TEMPORARY SUSPENDED)
                    this.showAlert(true, this.$t('reset-password-email-inactive'))
                    this.isShowRecaptchaV2 = false;
                    this.setInputState('email', false)
                    this.setInputState('password', false)
                    this.isNextButtonValid = false;
                    this.isCaptchaVerified = false;
                    this.forceRerender();
                    $$("#slide-captcha-container").show();
                  }else if(result.status == "WN00139"){ // SET PASSWORD
                    this.showAlert(true, this.$t('reset-password-no-password'))
                    this.isShowRecaptchaV2 = false;
                    this.setInputState('email', false)
                    this.setInputState('password', false)
                    this.isNextButtonValid = false;
                    this.isCaptchaVerified = false;
                    this.forceRerender();
                    $$("#slide-captcha-container").show();
                  } else {
                    // this.showAlert(true, this.$t('general-error-text') )
                    this.showAlert(true, this.$t('general-error-text', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}) )
                  }

                  this.hidePreloader();
                })

              });
            });

          }else{
            this.showAlert(true, this.$t('login-invalid-email-pass'));
            this.forceRerender();
            this.hidePreloader();
          }

        } else {
          //this.showAlert(true, this.$t('general-error-text'))
          //this.showAlert(true, this.$t('login-invalid-email-pass'));
          // refresh captcha
          this.$refs.sliderCaptcha.refresh()
          this.isCaptchaVerified = false;
          this.validateNextButton();
        }

      },
      showAlert(status, title, content){
        this.alertCard.show = status;
        if (title == undefined){
          title = "";
        }
        if (content == undefined){
          content = "";
        }
        this.alertCard.title= title;
        this.alertCard.content = content;

      },
      onRefresh(){
        console.log("REFRESH Captcha Image")
        this.isCaptchaVerified = false;
      },
      onFinish(){
        console.log("finish verify captcha")
      },
      onSuccess(){
        console.log("SLIDE CAPTCHA VERIFY : SUCCESS")
        this.isCaptchaVerified = true;
        /*let $$ = this.Dom7;
        $$("#slide-captcha-container").hide();*/
        this.isNextButtonValid = true;
      },
      onFail(){
        console.log("fail verify captcha")
        this.isCaptchaVerified = false;
      },
      openAppleSignIn() {
        if(window.AppleID) {
          this.appleSignIn(1, false);
        }
      },
      openGoogleSignIn() {
        this.$googleAuth.requestAccessToken();
      },
      backButton() {
          switch(this.routerTo) {
              default          : this.$f7router.navigate("/"); break;
          }
      },
      onFormInvalid(){
        this.alertCard.show  = true;
        this.alertCard.title = this.$t('login-invalid-email-pass');
      },
      showHidePassword(){
        let $$ = this.Dom7;
        /*
        if ($$('#password').attr("type") == "password")
        {
           $$('#password').attr("type", "text");
           $$("#password-icon").html('<i class="f7-icons">eye</i>');
        }
        else
        {
          $$('#password').attr("type", "password");
          $$("#password-icon").html('<i class="f7-icons">eye_slash</i>');
        }*/

        if(this.passwordInputType == "password"){
          this.passwordInputType = "text";
          $$("#password-icon").html('<i class="f7-icons">eye</i>');
        }else{
          this.passwordInputType = "password";
          $$("#password-icon").html('<i class="f7-icons">eye_slash</i>');
        }
      },
      forgotPassword(){
        this.$f7router.navigate("/reset-password-email?pid=login");
      }
    },
    components: {
      Recaptcha,
      SlideVerify,
      ModalInfo,
    },
    computed: {
      ...mapGetters('auth', [
            'authenticating',
            'authenticationError',
            'authenticationErrorCode',
            'authenticationSuccess'
        ]),
      ...mapGetters('misc', ['linkMarketing'])
    },
  }
</script>
